var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 *
 * @author Matthew Rawson @ 21/11/2018 13:30
 * @description
 * @notes
 */
import React, { PureComponent } from "react";
import id from "@irati/utils/id";
import { injectIntl } from "@irati/utils/lang";
import { HasPermissionTo } from "@irati/utils/permissions";
import authentication from "@irati/auth";
import SchedulesQuery from "@irati/insights/apollo/query/schedule/list";
import History from "@irati/utils/history";
import { extractFiltersFromLocation } from "@irati/insights/utils/analysis";
import { filterDemoCycles } from "@irati/insights/utils/demo";
import { DemoTenantContext, ReportsContext } from "@irati/insights/context";
import { mapSchedulesToOptions } from "@irati/insights/utils/mapping";
import TeamsQuery from "@irati/identity/apollo/query/Teams";
import { overrideAuth } from "@irati/insights/utils/apollo";
import { TeamState } from "@irati/types";
import Loading from "@irati/ui/src/Loading";
import { Page } from "../../components/Layout";
import { Breadcrumbs } from "../../components/Navigation";
import { CreateReport } from "../../components/Report";
import sitemap from "../sitemap";
import ReportList from "../../components/Report/ReportList";
var DEFAULT_SCHEDULE_VALUE = {
    label: "Select Survey",
    value: null
};
var Reports = /** @class */ (function (_super) {
    __extends(Reports, _super);
    function Reports(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            loadingReports: false
        };
        _this.reportList = React.createRef();
        _this.getScheduleListVariables = function (tenant) {
            return {
                tenant: tenant,
                orderBy: "createdAt",
                orderDirection: "DESC",
                withDrivers: true
            };
        };
        _this.onBeforeCreate = function () {
            if (_this.reportList.current) {
                _this.reportList.current.resetPagination();
            }
        };
        _this.loadingReports = function (loadingReports) {
            _this.setState({ loadingReports: loadingReports });
        };
        _this.filters = extractFiltersFromLocation(props.location);
        return _this;
    }
    Reports.prototype.render = function () {
        var _this = this;
        var loadingReports = this.state.loadingReports;
        return (React.createElement(DemoTenantContext.Consumer, null, function (_a) {
            var demoTenantAccessToken = _a.accessToken, cycleUuid = _a.cycleUuid, tenantUuid = _a.tenantUuid;
            var idNamespace = id("Reports", _this.props, { force: true });
            var isDemo = _this.filters.scheduleId === cycleUuid;
            var tenantId = isDemo ? tenantUuid : authentication.userTenant().uuid;
            return (React.createElement(HasPermissionTo, { permissions: "insights.reports" },
                React.createElement(Page, { id: idNamespace },
                    React.createElement(Breadcrumbs, { id: idNamespace, crumbs: [{ onClick: History.goBack, title: "insights.sitemap.back" }, sitemap.reports] }),
                    React.createElement(TeamsQuery, __assign({ variables: { tenantId: tenantId, state: TeamState.Generic } }, overrideAuth(demoTenantAccessToken, isDemo)), function (_a) {
                        var _b = _a.data, teamsData = (_b === void 0 ? {} : _b).teams;
                        var allTeams = (teamsData || []).results;
                        return (React.createElement(SchedulesQuery, __assign({ variables: _this.getScheduleListVariables(tenantId) }, overrideAuth(demoTenantAccessToken, isDemo)), function (_a) {
                            var results = _a.data.results;
                            var schedules = isDemo ? filterDemoCycles(results, cycleUuid) : results;
                            var scheduleOptions = mapSchedulesToOptions(schedules);
                            scheduleOptions.unshift(DEFAULT_SCHEDULE_VALUE);
                            return (React.createElement(ReportsContext.Provider, { value: {
                                    isDemo: isDemo,
                                    tenantId: tenantId,
                                    filters: _this.filters,
                                    onBeforeCreate: _this.onBeforeCreate,
                                    schedules: schedules,
                                    scheduleOptions: scheduleOptions,
                                    allTeams: allTeams,
                                    demoTenantAccessToken: demoTenantAccessToken,
                                    loadingReports: _this.loadingReports
                                } },
                                React.createElement(CreateReport, { id: idNamespace, loadingReports: _this.loadingReports }),
                                !loadingReports && React.createElement(ReportList, { ref: _this.reportList, id: idNamespace }),
                                loadingReports && React.createElement(Loading, null)));
                        }));
                    }))));
        }));
    };
    return Reports;
}(PureComponent));
export default injectIntl(Reports);
